import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2em;
  max-width: calc(100% - 2 * 134px);
  margin-left: 1.7em;
  margin-bottom: 5em;
`;

export const MainContent = styled.div`
  max-width: 400px;
`;

export const Title = styled.h1`
  font-weight: normal;
  font-size: 3.375rem;
  margin-top: 0;
`;
export const Description = styled.p`
  line-height: 200%;
  color: #999;
`;

export const Image = styled.img`
  max-width: 434px;
  width: 100%;
  margin-right: 6em;
  user-select: none;
`;

export const Container = styled.div`
  height: 674px;
  display: flex;
  align-items: center;
  margin-top: -4.9em;
  margin-bottom: 5em;
`;

export const DecorationLeft = styled.div`
  height: 441px;
  width: 134px;
  background: top left / contain no-repeat
    url("img/talk-to-us-left-decoration.png");
  margin-bottom: 92px;
`;

export const DecorationRight = styled.div`
  height: 651px;
  width: 134px;
  background: top right / contain no-repeat
    url("img/talk-to-us-right-decoration.png");
  margin-left: auto;
`;
